import {createRouter, createWebHistory} from 'vue-router'
import NProgress from 'nprogress'//引入nprogress
// import 'nprogress/nprogress.css' //这个样式必须引入
import store from '../store'

const admin_path = ''
const routes = [
    // {
    //     path: '/mglogin',
    //     name: 'mglogin',
    //     component: () => import('@/views/login')
    // },
    {
        path: admin_path,
        component: () => import('@/views/main'),
        redirect: admin_path+'',
        children: [
            {
                path: admin_path +'',
                name: 'home',
                component: () => import('@/views/home'),
                meta: {label: '首页'},
            },
            {
                path: admin_path +'/news/:id',
                name: 'news',
                component: () => import('@/views/news'),
                meta: {label: '文章内容'},
            },
            {
                path: admin_path +'/free',
                name: 'free',
                component: () => import('@/views/free'),
                meta: {label: '免费分析'},
            },
            {
                path: admin_path +'/free/dan',
                name: 'dan',
                component: () => import('@/views/dan'),
                meta: {label: '单场精选'},
            },
            {
                path: admin_path +'/expert',
                name: 'expert',
                component: () => import('@/views/expert'),
                meta: {label: '专家分析'},
            },
            {
                path: admin_path +'/match/:id',
                name: 'match',
                component: () => import('@/views/match'),
                meta: {label: '推荐信息'},
            },
            {
                path: admin_path +'/subscribe',
                name: 'subscribe',
                component: () => import('@/views/account/subscribe'),
                meta: {label: '我的订阅'},  //, keepAlive: false
            },
            {
                path: admin_path +'/cost',
                name: 'cost',
                component: () => import('@/views/account/cost'),
                meta: {label: '我的交易'},
            },
            {
                path: admin_path +'/recharge',
                name: 'recharge',
                component: () => import('@/views/account/recharge')
            },
            {
                path: admin_path +'/account',
                name: 'account',
                component: () => import('@/views/account/info')
            },
            {
                path: admin_path +'/help',
                name: 'help',
                component: () => import('@/views/help')
            },
        ]
    },
    {
        path: '/:pathMatch(.*)',
        redirect: '/404',
        component: () => import('@/views/main'),
        children: [
            {
                path: '/404', // 这里要加上/404,和上面的redirect对应,必须加上/
                name: '404',
                component: () => import('@/views/error'),
            },
        ],
    },
]

const router = createRouter({
    history: createWebHistory(),
    routes
})

router.beforeEach((to, from, next) => {
    // console.log(to.meta.keepAlive)
    if(to.meta.keepAlive === undefined){
        to.meta.keepAlive = true
    }
    // let that = this
    // if(to.name === 'mglogin'){
    //     if(store.getters.isLogin){
    //         next({path: '/maginc/home'})
    //         // console.log('去首页')
    //     }
    // }
    // else{
    //     if(!store.getters.isLogin){
    //         next({path: '/mglogin'})
    //         // console.log('去登录')
    //     }
    // }
    next()
})

router.afterEach((to, from, next)=>{
    NProgress.done()
    // console.log(to.meta)
})

export default router
